import { Fragment, useState } from "react";
import { Btn, H3 } from "../../../../../AbstractElements";
import { OlivaSignUp, OpenModalOliva } from "../../../../../Utils/Constants";
import { Modal, ModalHeader } from "reactstrap";
import FormModalBody from "./FormModalBody";

export default function OlivaModal() {
    const [modal, setModal] = useState<boolean>(false);
    const toggle = () => { setModal(!modal); }
    return (
        <Fragment>
            <Btn color='primary' type="button" onClick={toggle}>{OpenModalOliva}</Btn>
            <Modal isOpen={modal} toggle={toggle}>
                <div className="modal-toggle-wrapper text-start dark-sign-up">
                    <ModalHeader className="justify-content-center border-0"><H3 className="f-w-600">{OlivaSignUp}</H3></ModalHeader>
                    <FormModalBody/>
                </div>
            </Modal>
        </Fragment>
    )
}
